import React, { FunctionComponent, useCallback, useState } from 'react'
import { StepIndicator } from '../components/step-indicator/StepIndicator'
import { UsersImportStep } from '../types/UserImportStep'
import { UploadProgress } from './components/UploadProgress'
import { SelectDataSource } from './components/SelectDataSource'
import { useUploadUsersImport } from './hooks/useUploadUsersImport'
import { linkBuilder } from 'shared/linkBuilder'
import { Redirect } from 'react-router-dom'

export const CreateUsersImport: FunctionComponent = () => {
  const { processUpload, uploadProgress } = useUploadUsersImport()
  const [loading, setLoading] = useState(false)
  const [userImportId, setUserImportId] = useState<number>()

  const submitFile = useCallback(
    async (file: File) => {
      setLoading(true)
      try {
        const { id } = await processUpload(file)
        setUserImportId(id)
      } catch (e) {
        setLoading(false)
        throw e
      }
    },
    [processUpload, setLoading, setUserImportId]
  )

  if (userImportId) {
    return <Redirect push to={linkBuilder.userImport(userImportId)} />
  }

  return (
    <div className="CreateUsersImportPage">
      <StepIndicator currentStep={UsersImportStep.DATA} loading={loading} />
      {!loading && <SelectDataSource submitFile={submitFile} />}
      {loading && uploadProgress && (
        <UploadProgress progress={uploadProgress} />
      )}
    </div>
  )
}
